export default __webpack_public_path__ + "static/c12-5d137240775ea6527027ef2384ad3ee5.png";